import { request } from "apis/base";
import { ReportParamsType } from "constants/types/common";

export const reportApi = {
  getProfitReport: (params: ReportParamsType) =>
    request({ url: "/report/profit", method: "GET", params }),

  exportProfitReport: (params: ReportParamsType) =>
    request({
      url: "/report/profit/export",
      method: "GET",
      params,
      responseType: "blob",
    }),

  getCollectionReport: (params: ReportParamsType) =>
    request({ url: "/report/payment-detail", method: "GET", params }),

  getPurchaseReport: (params: ReportParamsType) =>
    request({ url: "/report/purchase-detail", method: "GET", params }),

  /** Excel "Tình hình mua hàng" — mỗi dòng một mặt hàng trên đơn mua */
  exportPurchaseReport: (params: ReportParamsType) =>
    request({
      url: "/report/purchase-detail/export",
      method: "GET",
      params,
      responseType: "blob",
    }),

  /** Excel "Tình hình thu tiền" — mỗi dòng một phiếu thu, lọc theo ngày thu */
  exportCollectionReport: (params: ReportParamsType) =>
    request({
      url: "/report/payment-detail/export",
      method: "GET",
      params,
      responseType: "blob",
    }),
};
